import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrequalificationsEditComponent } from './prequalifications-edit/prequalifications-edit.component';
import { PrequalificationsViewComponent } from './prequalifications-view/prequalifications-view.component';
import { PrequalificationsComponent } from './prequalifications.component';
import { AuthGuard } from '../guards/auth.guard';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';

const routes: Routes = [
  {
    path: 'prequalifications',
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.PRE_QUALIFICATIONS },
    children: [
      { path: '', component: PrequalificationsComponent },
      { path: ':id/edit', component: PrequalificationsEditComponent },
      { path: ':id/view', component: PrequalificationsViewComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrequalificationsRoutingModule {}
